module.exports = __webpack_public_path__ + "img/api-task.3715286d.svg";